// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_l7-0";
export var discountCodeInput = "_l7-1";